import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";
import { GoogleAuthProvider, getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const storage = getStorage(app);

/* ---------------------------
   ANALYTICS SAFE
--------------------------- */

export let analytics = null;

isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

/* ---------------------------
   MESSAGING SAFE
--------------------------- */

export async function getFirebaseMessagingSafe() {
  try {
    if (typeof window === "undefined") return null;

    const supported =
      "serviceWorker" in navigator &&
      "Notification" in window;

    if (!supported) return null;

    return getMessaging(app);
  } catch (e) {
    console.error("Messaging not supported:", e);
    return null;
  }
}

/* ---------------------------
   DEBUG
--------------------------- */

if (process.env.NODE_ENV !== "production") {
  console.log("Firebase project:", process.env.REACT_APP_PROJECT_ID);
  console.log("Firebase config", firebaseConfig);
}